module.exports = __webpack_public_path__ + "static/media/class (16).ab9b4a21.webp";